import React from 'react';
import './index.css';
import { headTools } from '../../tools/headTools';

export const HeadToolbar = ({ onToolClick }) => {
  return (
    <div className='headToolbar'>
      {headTools.map((headTool, i) => (
        <div onClick={() => onToolClick(headTool.id)} key={i} className='headTool-box'>
          <div className='headToolIcon-box'>
            <img src={headTool.icon} alt={headTool.title} />
          </div>
          <div className='headToolText-box'>
            <h1>{headTool.titleUz}</h1>
            <p>{headTool.titleEng}</p>
          </div>
        </div>
      ))}
    </div>
  );
};
